import "react-native-get-random-values";
import "react-native-gesture-handler";
import "@expo/metro-runtime";
import React, { useEffect, useState } from "react";
import Constants from "expo-constants";
import * as SplashScreen from "expo-splash-screen";
import { filterErrors } from "@utils/errors-logger";
import NavigationBase from "@navigations/index";
import "./src/global.css";
import { Platform, I18nManager } from "react-native";
import { useInAppMessageHandler } from "./src/hooks/useInAppMessageHandler";
import { useAppSettings } from "@redux/slices/globalSlice";
import ErrorBoundary from "./src/components/common/ErrorBoundary";
import CacheBusterWrapper from "@components/CacheBusterWrapper/CacheBurstWrapper";

const AppProvider =
  Platform.OS === "web"
    ? React.lazy(() => import("@components/common/AppProviders"))
    : require("@components/common/AppProviders").default;

const ContactUsHandler =
  Platform.OS === "web"
    ? React.lazy(() => import("@components/organisms/ContactUsHandler"))
    : require("@components/organisms/ContactUsHandler").default;

filterErrors();

I18nManager.allowRTL(false);
I18nManager.forceRTL(false);

SplashScreen.preventAutoHideAsync();

function AppContent() {
  const [showSheet, setShowSheet] = useState(false);
  const getAppSettings = useAppSettings();
  const timeNeedsWork = getAppSettings?.timeNeedsWork || 14;
  const firstNotificationTime = getAppSettings?.firstNotificationTime || 24;

  const handleCloseSheet = () => {
    setShowSheet(false);
  };

  const {
    showSuccessPopup,
    setSuccessResponseData,
    successResponseData,
    handleClose,
    handleOpenSuccessPopup,
  } = useInAppMessageHandler({
    onOpenFeedbackSheet: () => setShowSheet(true),
    timeNeedsWork,
    firstNotificationTime,
  });

  return (
    <>
      <NavigationBase />
      <ContactUsHandler
        showSheet={showSheet}
        handleCloseSheet={handleCloseSheet}
        screenName="App Screen"
        showSuccessPopup={showSuccessPopup}
        handleClose={handleClose}
        setSuccessResponseData={setSuccessResponseData}
        handleOpenSuccessPopup={handleOpenSuccessPopup}
        successResponseData={successResponseData}
        subjectPrefix="more.contactUs.feedback.text"
      />
    </>
  );
}

function App() {
  useEffect(() => {
    if (Platform.OS === "web") {
      const viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      viewportMeta.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      document.head.appendChild(viewportMeta);
    }
  }, []);

  return (
    <CacheBusterWrapper>
      <ErrorBoundary>
        <AppProvider>
          <AppContent />
        </AppProvider>
      </ErrorBoundary>
    </CacheBusterWrapper>
  );
}

let AppEntryPoint = App;

if (__DEV__ && Constants?.expoConfig?.extra?.storybookEnabled === "true") {
  try {
    AppEntryPoint = require("./.ondevice").default;
  } catch {}
}

export default AppEntryPoint;
